import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Tooltip as MuiTooltip } from "@mui/material";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const StackedBarChart = ({ data }) => {
  const chartRef = useRef(null);

  if (!data || data.length === 0) return <p>No data available</p>;

  const total = data[0].drg_change_count + data[0].drg_no_change_count;
  const drgErrorRate =
    total > 0 ? ((data[0].drg_change_count / total) * 100).toFixed(2).replace(/\.00$/, "") : "0";
    const hasValidData = data[0]?.drg_no_change_count > 0 || data[0]?.drg_change_count > 0;
  const chartData = {
    labels: [""],
    datasets: [
      {
        label: "DRG No Change",
        data: [data[0]?.drg_no_change_count || 0],
        backgroundColor: "#ADB2D4",
        barThickness: 90,
      },
      {
        label: "DRG Change",
        data: [data[0]?.drg_change_count || 0],
        backgroundColor: "#818C78",
        barThickness: 90,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide default legend
      },
tooltip: {
  enabled: true,
  callbacks: {
    label: function (context) {
      const datasetLabel = context.dataset.label || "";
      if (datasetLabel === "DRG No Change") {
        return [
          "Episodes with the same",
          "'Original DRG' and status",
          "of Reviewed, no change.",
        ];
      } else if (datasetLabel === "DRG Change") {
        return [
          "Episodes with a different",
          "'DRG Code' and 'Audit DRG'",
          "with status of Reviewed, Recoded.",
        ];
      }
      return datasetLabel;
    },
  },
  bodyFont: {
    size: 12,
   
  },
  padding: 10, // Increase padding for better visibility
  backgroundColor: "rgba(0,0,0,0.8)", // Darker background for better readability
},
      datalabels: {
        display: (context) => context.dataset.data[context.dataIndex] > 0,
        color: "black",
        anchor: "center",
        align: "center",
        font: { size: 14 },
      },
    },
    scales: {
      x: { stacked: true, grid: { display: false }, ticks: { display: false }, border: { display: false } },
      y: { stacked: true, grid: { display: false }, ticks: { display: false }, border: { display: false } },
    },
  };

  const legendItems = [
    {
      label: "DRG No Change",
      color: "#ADB2D4",
      description: "Episodes with the same 'Original DRG' and status of Reviewed, no change.",
    },
    {
      label: "DRG Change",
      color: "#818C78",
      description: "Episodes with a different 'DRG Code' and 'Audit DRG' with status of Reviewed, Recoded.",
    },
  ];

  return (
    <>
      <div style={{ marginBottom: "16px", textAlign: "center",fontWeight:"500" }}>
        <span className="highlight-box">{drgErrorRate}%</span> DRG error rate
      </div>
      <div className="stacked-bar-chart-image"
        style={{
          width: "100%",
          height: "165px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >{
        hasValidData&&<Bar ref={chartRef} data={chartData} options={options} />
      }
        
      </div>

      {/* Custom Legend with MUI Tooltip */}
      <div style={{ display: "flex", justifyContent: "center", gap: "16px", }}>
        {legendItems.map((item, index) => (
          <MuiTooltip key={index} title={item.description} placement="top" arrow>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: "6px",
                padding: "4px 8px",
                borderRadius: "4px",
                // background: "#f5f5f5",
              }}
            >
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: item.color,
                  display: "inline-block",
                  // borderRadius: "50%",
                }}
              ></span>
              <span style={{ fontSize: "12px" }}>{item.label}</span>
            </div>
          </MuiTooltip>
        ))}
      </div>
    </>
  );
};

export default StackedBarChart;
